import { Context, createContext } from 'preact';

const TranslationContext: Context<any> = createContext({});

export default TranslationContext;
